module.exports = __webpack_public_path__ + "static/media/9DESA9.901a1377.jpg";